import { useState } from 'react';
import { toast } from 'sonner';
import { supabase } from '@/lib/supabase';

export const NEXT_KEY = 'mymusic_auth_next';

export function startGoogleOAuth(next = '/app', { link = false, reauth = false } = {}) {
  sessionStorage.setItem(NEXT_KEY, next);
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const redirectTo = `${window.location.origin}/auth/callback`;
  const opts = { provider: 'google', options: { redirectTo, ...(reauth ? { queryParams: { prompt: 'select_account' } } : {}) } };
  return link ? supabase.auth.linkIdentity(opts) : supabase.auth.signInWithOAuth(opts);
}

function GoogleG() {
  return (
    <svg viewBox="0 0 48 48" className="h-5 w-5" aria-hidden="true">
      <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.7 32.7 29.2 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.4-.4-3.5z" />
      <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 15.1 19 12 24 12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 16.3 4 9.7 8.3 6.3 14.7z" />
      <path fill="#4CAF50" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2C29.2 35.1 26.7 36 24 36c-5.2 0-9.6-3.3-11.3-8l-6.5 5C9.5 39.6 16.2 44 24 44z" />
      <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.2-4.1 5.6l6.2 5.2C37 39.2 44 34 44 24c0-1.3-.1-2.4-.4-3.5z" />
    </svg>
  );
}

export function GoogleAuthButton({ next = '/app', label = 'Continuer avec Google', link = false, testId = 'google-auth-button' }) {
  const [busy, setBusy] = useState(false);
  const go = async () => {
    if (!supabase) return;
    setBusy(true);
    const { error } = await startGoogleOAuth(next, { link });
    if (error) {
      setBusy(false);
      toast.error(link ? "Liaison Google indisponible pour le moment." : 'Connexion Google indisponible pour le moment.');
    }
  };
  return (
    <button type="button" onClick={go} disabled={busy || !supabase} data-testid={testId}
            className="flex w-full items-center justify-center gap-3 rounded-full border border-[#dadce0] bg-white py-3 font-medium text-[#1f1f1f] transition-transform hover:scale-[1.01] hover:bg-[#f8f9fa] disabled:opacity-60">
      <GoogleG /> <span>{busy ? 'Redirection…' : label}</span>
    </button>
  );
}

export function OrDivider() {
  return (
    <div className="my-5 flex items-center gap-3 text-xs uppercase tracking-widest text-muted-foreground">
      <span className="h-px flex-1 bg-border" /> ou <span className="h-px flex-1 bg-border" />
    </div>
  );
}
